import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ModalController, Platform} from '@ionic/angular';
import {SearchSitePage} from 'src/app/modals/search-site/search-site.page';
import {LokijsService} from '../../services/database/lokijs.service';
import {SiteModel} from '../../models/site.model';
import {DocumentModel} from '../../models/document.model';
import {DetaillineDTOModel} from '../../models/detaillineDTO.model';
import {MobileConfigurationModel} from '../../models/mobile-configuration.model';
import {ConfigurationService} from '../../services/configuration.service';

@Component({
    selector: 'site',
    templateUrl: './site.component.html',
    styleUrls: ['./site.component.scss'],
})
export class SiteComponent implements OnInit {

    @Input() document: DocumentModel;
    @Output() siteChange: EventEmitter<any> = new EventEmitter<any>();
    siteList: any;
    mobileConfig: MobileConfigurationModel;

    constructor(private modalController: ModalController,
                private lokiJs: LokijsService,
                private configService: ConfigurationService,
                private platform: Platform) {
    }

    async ngOnInit() {
        this.mobileConfig = await this.configService.getMobileConfiguration();
        if (!this.document.site) {
            this.document.site = new SiteModel();
        }
    }

    async openModalSearch() {
        if (this.document.customer.cod) {
            this.siteList = this.lokiJs.getCollection('site').chain().find({'cust': this.document.customer.cod}).data();
            console.log('Site List: ', this.siteList);
        }
        const modal = await this.modalController.create({
            component: SearchSitePage,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'siteList': this.siteList,
                'document': this.document
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
                if (this.document.site.id !== dataReturned.data.id) {
                    this.siteChange.emit(dataReturned.data);
                }
                this.document.site = dataReturned.data;
            }
        });
        return await modal.present();
    }

    navigateToSite() {
        let coordinates = '';
        if (this.document.site.latitude && this.document.site.longitude) {
            coordinates = this.document.site.latitude + ',' + this.document.site.longitude;
        } else {
            if (this.document.site.add1) {
                coordinates += this.document.site.add1;
            }
            if (this.document.site.add2) {
                coordinates += '+' + this.document.site.add2;
            }
            if (this.document.site.add3) {
                coordinates += '+' + this.document.site.add3;
            }
            if (this.document.site.add4) {
                coordinates += '+' + this.document.site.add4;
            }
        }
        console.log(coordinates);
        if (this.platform.is('ios')) {
            window.open('maps:?q=' + coordinates, '_system', 'location=yes');
        } else {
            window.open('geo:?q=' + coordinates, '_system', 'location=yes');
        }
    }

    clearSite() {
        // Used for Scaffolding returns
        // Clear the detail lines to avoid filter clashing
        this.document.site = new SiteModel();
        if (this.mobileConfig.mobilehireScaffoldingInUse === 1) {
            this.document.detailLines = new Array<DetaillineDTOModel>();
        }
        this.siteChange.emit(new SiteModel());
    }
}
